export const redirectUrl = 'https://www.sleepnumber.com/categories/mattresses'
